import { includes } from 'lodash';

import { isGuidanceObject, withGuidanceV2 } from 'common/core/approvals';

import Environment from 'StorytellerEnvironment';
import { type StoryViewRights } from 'types';

/**
 * Checks to see if the story you are viewing is published
 * @returns boolean
 */
export const isStoryPublished = () => {
  // Checks to see if the story is a published version
  return Environment.IS_STORY_PUBLISHED;
};

/**
 * Checks to see if the user can publish the current story
 * @returns boolean
 */
export const canPublishCurrentStory = (UserAuthorization?: { viewRights: StoryViewRights }) => {
  const isOwner = includes(UserAuthorization?.viewRights, 'grant');
  return isOwner;
};

/**
 * Determine if the current story will enter an approval queue
 * @returns boolean
 */
export const storyWillEnterApprovalsQueue = (): boolean => {
  return !!(
    isGuidanceObject(Environment.APPROVALS_GUIDANCE) &&
    withGuidanceV2(Environment.APPROVALS_GUIDANCE).willEnterApprovalQueue()
  );
};

/**
 * Generates the correct url for copying a story
 * This url is different depending on if you are copying a published
 * or draft story
 * @returns String
 */
export const getCopyAPIUrl = () => {
  const action = isStoryPublished() ? 'copy_published' : 'copy';
  return `/stories/s/${Environment.STORY_UID}/${action}`;
};

/**
 * Check if the type of component is movable in the story
 * @param componentType
 * @returns boolean
 */
export const isComponentTypeMovable = (componentType: string): boolean => {
  return includes(
    [
      'assetSelector',
      'socrata.visualization.classic',
      'embeddedHtml',
      'image',
      'measure.card',
      'measure.chart',
      'socrata.visualization.barChart',
      'socrata.visualization.choroplethMap', // legacy
      'socrata.visualization.calendar',
      'socrata.visualization.columnChart',
      'socrata.visualization.comboChart',
      'socrata.visualization.scatterChart',
      'socrata.visualization.featureMap',
      'socrata.visualization.histogram',
      'socrata.visualization.map',
      'socrata.visualization.pieChart',
      'socrata.visualization.regionMap',
      'socrata.visualization.table',
      'socrata.visualization.agTable',
      'socrata.visualization.timelineChart',
      'socrata.visualization.vizCanvas',
      'story.tile',
      'story.widget',
      'youtube.video',
    ],
    componentType,
  );
};
